import { ComingSoonPage } from '@todo/web-ui/components/coming-soon-page';

export default function AccountPage() {
  return <ComingSoonPage page="account" />;
}
